import React from 'react';

import InformationModal from 'shared/components/modal/informationModal';
import TableComponent from 'shared/components/table/table';
import TableBody from 'shared/components/table/tableBody';
import TableHeader from 'shared/components/table/tableHeader';
import { IAccessType } from './inviteForm';
import TableRow from 'shared/components/table/tableRow';
import TableCell from 'shared/components/table/tableCell';
import { CloseIcon, RightIcon } from 'shared/icon';

interface IProps {
	show: boolean;
	onClose: () => void;
}

const AccessTypeViewModal: React.FC<IProps> = (props) => {
	const { show, onClose } = props;

	return (
		<InformationModal
			headerTile={'Access type'}
			subHederTitle={'Info the access type to the platform'}
			show={show}
			onClose={onClose}
			size={'4xl'}
		>
			<TableComponent className='rounded-xl border'>
				<TableHeader
					headerTitleClassName='!text-wrap text-xs'
					tableCellList={ACCESS_TYPE_TABLE_CELL}
					className='sticky top-0 z-[1] table w-full table-fixed bg-white first:text-left
					'
				/>
				<TableBody className='custom-scrollbar block overflow-y-auto border-none'>
					{ACCESS_TYPE_INFO.map((data: IAccessType) => {
						return (
							<TableRow key={data.id} className='table w-full table-fixed'>
								{ACCESS_TYPE_TABLE_CELL.map((cell) => (
									<TableCell
										key={cell.title}
										className='border-b px-4 py-3 text-center align-middle w-full'
									>
										<div className='flex items-center justify-center text-xs font-medium text-[#344054]'>
											{cell.key === 'userLevelAccess' ? (
												<span className='text-xs'>{data.userLevelAccess}</span>
											) : data[cell.key as keyof IAccessType] ? (
												<RightIcon height='16px' width='16px' stroke='#1D9533' />
											) : (
												<CloseIcon height='12px' width='12px' stroke='red' />
											)}
										</div>
									</TableCell>
								))}
							</TableRow>
						);
					})}
				</TableBody>
			</TableComponent>
		</InformationModal>
	);
};

export default AccessTypeViewModal;

const ACCESS_TYPE_TABLE_CELL = [
	{ title: 'User Level Access', key: 'userLevelAccess', style: { width: '70px' } },
	{ title: 'Read', key: 'levelOne', style: { width: '70px' } },
	{ title: 'Create', key: 'levelTwo', style: { width: '70px' } },
	{ title: 'Update', key: 'levelThree', style: { width: '70px' } },
	{ title: 'Delete', key: 'levelFour', style: { width: '70px' } }
];

const ACCESS_TYPE_INFO = [
	{
		id: 1,
		userLevelAccess: 'Level 1 (Super Admin)',
		levelOne: true,
		levelTwo: true,
		levelThree: true,
		levelFour: true,
		levelFive: true
	},
	{
		id: 2,
		userLevelAccess: 'Level 2 (Manager)',
		levelOne: true,
		levelTwo: true,
		levelThree: true,
		levelFour: true,
		levelFive: true
	},
	{
		id: 3,
		userLevelAccess: 'Level 3 (Team/Collaborator)',
		levelOne: true,
		levelTwo: false,
		levelThree: true,
		levelFour: true,
		levelFive: false
	},
	{
		id: 4,
		userLevelAccess: 'Level 4 (Read-Only Access)',
		levelOne: true,
		levelTwo: false,
		levelThree: false,
		levelFour: false,
		levelFive: false
	}
];
